import { ExportHistoryView } from "./export-history-view";
import { useExportHistory } from "./use-export-history";

export default function ExportHistory() {
  const logic = useExportHistory();
  return <ExportHistoryView {...logic} />;
}
